import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=252d4754&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=js&"
export * from "./Management.vue?vue&type=script&lang=js&"
import style0 from "./Management.vue?vue&type=style&index=0&id=252d4754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d4754",
  null
  
)

export default component.exports